let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;

  setTimeout(function () {

  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-cart-drawer.css?v=101177292668009243061792055495");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/swiper-bundle.css?v=183092761113033764571772525847");
  //loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-rating.css?v=24573085263941240431772525846");
  
  //Dynamically load JavaScript files  
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/Product-Compare-image.js?v=69279039125807090501781785946");
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/review.js?v=179122652022389052751772525846");
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/swiper-bundle.js?v=30986975797822707101772525848");
  //loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/marquee.js?v=149530619952598007711772525848");
  //loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/marquee.js?v=149530619952598007711772525848");
  //loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/marquee.js?v=149530619952598007711772525848");
  //loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/marquee.js?v=149530619952598007711772525848");
  //loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/cart-notification.js?v=160453272920806432391772525848");
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/quick-add.js?v=21087258723263848871772525846");
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/search-form.js?v=113639710312857635801772525846");
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/predictive-search.js?v=21556096761500878031772525847");
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/product-form.js?v=83344412470625808751779528421");
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/details-disclosure.js?v=153497636716254413831772525847");
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/details-modal.js?v=4511761896672669691772525848");
  loadScript("//moxiebeautio.shop/cdn/shop/t/115/assets/pubsub.js?v=2921868252632587581772525845");
  
  

  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/section-footer.css?v=171161867995400310821772525846");
  //loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-newsletter.css?v=103472482056003053551772525848");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/sr-checkout-styles.css?v=52668433763885547751774953688");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-cart.css?v=61086454150987525971772525846");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-cart-items.css?v=73357622004024540021772525845");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-cart-notification.css?v=108833082844665799571772525845");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-discounts.css?v=152760482443307489271772525847");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-totals.css?v=86168756436424464851772525848");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-list-payment.css?v=69253961410771838501772525845");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-list-social.css?v=52211663153726659061772525845");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-list-menu.css?v=151968516119678728991772525848");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-search.css?v=110505427807447362961772525847");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-predictive-search.css?v=68801219296741410351772525845");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/before.css?v=27895467328548674691772525845");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/Product-Compare-image.css?v=177988552912209244671781785945");
  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/before.css?v=27895467328548674691772525845");


  loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-loading-overlay.css?v=63222060604405645311779528418");
  // loadCSS("//moxiebeautio.shop/cdn/shop/t/115/assets/component-card.css?v=168685987607774519451772525847");

  // Load the font
  loadFont();

  loadScriptWithDelay("//moxiebeautio.shop/cdn/shop/t/115/assets/app.js?v=76605918543419509861780563796", 200);
  }, 10);

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

// Check if the user is beyond 400px from the top
if (window.scrollY >= 400) {
  loadScripts(); // Load immediately if user is already past 400px
} else {
  // Wait for user interaction
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadScriptWithDelay(src, delay) {
  setTimeout(() => {
    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  }, delay);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}


// Helper function to load the font dynamically
function loadFont() {
  var style = document.createElement('style');
  style.textContent = `
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-100.woff2?v=1692617651');
      font-weight: 100;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-200.woff2?v=1692617651');
      font-weight: 200;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-300.woff2?v=1692617651');
      font-weight: 300;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-400.woff2?v=1692617651');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-500.woff2?v=1692617651');
      font-weight: 500;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-700.woff2?v=1692617651');
      font-weight: 700;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-800.woff2?v=1692617651');
      font-weight: 800;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'master'; 
      src: url('https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Haskoy-900.woff2?v=1692617651');
      font-weight: 900;
      font-style: normal;
      font-display: swap;
    }
  `;
  document.head.appendChild(style);
}
